// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/profilecard/loader/index.scss
// module id = 3019
// module chunks = 13